import { TouchSpin } from "../../../../../../../Avency.Nwd.Shop/Resources/Private/Assets/JavaScripts/Project/Functions/TouchSpin";
import { Popover } from "bootstrap";

(function ($) {
    if ($('.first-articles').length === 1) {
        $.ajax({
            url: $('.first-articles').data('first-articles-url'),
            dataType: 'html',
            method: 'get',
            complete: function (response, statusCode) {
                $('.first-articles').html(response.responseText);

                TouchSpin.init('input[type="number"]');
                window.initAvailabilityPopovers();

                $('.first-articles').find('[data-bs-toggle="popover"]').each((index, elem) => {
                    Popover.getOrCreateInstance(elem, {
                        container: 'body'
                    });
                });

                if ($('.first-articles').find('.equalize-height').length > 0) {
                    $('.first-articles').find('.equalize-height').equalHeights('reset').equalHeights();
                }

                $('.first-articles').find('*[data-annotations]').annotations();
                $('.first-articles').find('.price-async').prices();
                $('.first-articles').find('.shopping-button-async').shoppingButton();
                $('.first-articles').find('*[data-fetch-article-buy]').articleBuy();

                Waypoint.refreshAll();
            }
        });
    }

    const promotionHeader = $('.promotion-search-header');
    if (promotionHeader.length === 1) {
        $.ajax({
            url: promotionHeader.data('promotion-search-header-url'),
            dataType: 'html',
            method: 'get',
            complete: function (response, status) {
                $('.promotion-search-header').html(response.responseText);
                const promotionHeader = $('.promotion-search-header');

                promotionHeader.find('img').each(function () {
                    waitForImage(this).then(() => {
                        if (promotionHeader.find('.equalize-height').length > 0) {
                            promotionHeader.find('.equalize-height').equalHeights('reset').equalHeights();
                        }

                        Waypoint.refreshAll();
                    });
                });

                window.addEventListener('resize', function () {
                    if (promotionHeader.find('.equalize-height').length > 0) {
                        promotionHeader.find('.equalize-height').equalHeights('reset').equalHeights();
                    }

                    Waypoint.refreshAll();
                }, false);
            }
        });
    }

    const contentSearchHeader = $('.content-search-header');
    if (contentSearchHeader.length === 1) {
        /**
         * Load more content results and append them to the content search header.
         */
        function loadMoreContentResults() {
            let page = contentSearchHeader.data('page');
            let url = contentSearchHeader.data('content-search-header-url') + '&page=' + page;
            let loadMoreBtn = contentSearchHeader.find('.content-search-load-more');

            /**
             * Handle the response of the GET request.
             * @param {string} data - The data returned from the server.
             */
            $.get(url, function (data) {
                if (data === '' || data === null || data === undefined) {
                    return;
                }

                $(contentSearchHeader).removeClass('d-none');

                loadMoreBtn.remove();
                contentSearchHeader.append(data);
                contentSearchHeader.data('page', page + 1);

                loadMoreBtn = contentSearchHeader.find('.content-search-load-more');
                let contentItems = contentSearchHeader.find('.content-search-item');

                if (loadMoreBtn.hasClass('has-no-redirect')) {
                    contentItems.hide().first().show();
                    loadMoreBtn.on('click', loadContentWithoutRedirect);
                } else {
                    loadMoreBtn.on('click', loadMoreContent);
                }

                contentItems.filter(':visible').removeClass('last-child').last().addClass('last-child');

                // hide no-result text if there are results
                if ($('.search-list-header-wrapper[data-search-result-count="0"]').length > 0) {
                    $('.search-list-header-wrapper[data-search-result-count="0"]').remove();
                    $('.search-list-wrapper[data-search-result-count="0"]').remove();
                    $('.content-search-load-more .load-more-button').click();
                }
            });
        }

        /**
         * Load more content results and hide the load more button.
         */
        function loadMoreContent() {
            loadMoreContentResults();
            $(this).css('visibility', 'hidden');
        }

        /**
         * Load content without redirect, show all content items and manage the visibility of the load more button.
         */
        function loadContentWithoutRedirect() {
            contentSearchHeader.find('.content-search-item').show();
            let visibleItems = contentSearchHeader.find('.content-search-item:visible');
            visibleItems.removeClass('last-child').last().addClass('last-child');

            if ($(this).hasClass('has-no-redirect')) {
                $(this).removeClass('has-no-redirect');
            } else {
                loadMoreContentResults();
                $(this).css('visibility', 'hidden');
            }
        }

        loadMoreContentResults();
    }

    function waitForImage(imgElem) {
        return new Promise(res => {
            if (imgElem.complete) {
                return res();
            }
            imgElem.onload = () => res();
            imgElem.onerror = () => res();
        });
    }
})(jQuery);
